// @ts-check
export const RECORD_OPEN = 'RECORD_OPEN';
export const RECORD_SHUT = 'RECORD_SHUT';
export const ENTER = 'ENTER';
export const LEAVE = 'LEAVE';
export const CLEAR = 'CLEAR';
export const ENABLE = 'ENABLE';
export const DISABLE = 'DISABLE';
